import React from "../../../__snowpack__/pkg/react.js";
import {Checkbox, Row, Col, Tooltip} from "../../../__snowpack__/pkg/antd.js";
import {chunk, isEqual} from "../../../__snowpack__/pkg/lodash.js";
export const FormItemShop = (props) => {
  const {formatMessage, form, formKey, shopList} = props;
  const shopIdList = shopList.map((shop) => shop.shopId);
  const initShops = form.getFieldValue(formKey);
  const equal = isEqual(initShops ? initShops.sort() : [], shopIdList.sort());
  return /* @__PURE__ */ React.createElement(Checkbox.Group, {
    value: equal ? ["ALL", ...shopIdList] : initShops,
    style: {display: "block"},
    onChange: (checkedValue) => {
      if (checkedValue.includes("ALL") && checkedValue.length - 1 === initShops.length) {
        form.setFieldsValue({
          [formKey]: shopIdList
        });
      } else if (checkedValue.includes("ALL") && checkedValue.length < initShops.length) {
        form.setFieldsValue({
          [formKey]: checkedValue.filter((item) => item !== "ALL")
        });
      } else if (checkedValue.length === initShops.length && !checkedValue.includes("ALL")) {
        form.setFieldsValue({
          [formKey]: []
        });
      } else {
        form.setFieldsValue({
          [formKey]: checkedValue
        });
      }
      props.onUpdate && props.onUpdate();
    }
  }, chunk([{shopName: "All", shopId: "ALL"}, ...shopList], 6).map((group, idx) => {
    return /* @__PURE__ */ React.createElement(Row, {
      key: idx,
      style: {marginTop: 16}
    }, /* @__PURE__ */ React.createElement(Col, {
      style: {
        minWidth: 60,
        marginRight: 10,
        textAlign: "right"
      }
    }, /* @__PURE__ */ React.createElement("span", {
      className: "header-form-title"
    }, idx === 0 ? `${formatMessage({id: "Store"})}:` : "")), /* @__PURE__ */ React.createElement(Col, {
      span: "20"
    }, /* @__PURE__ */ React.createElement(Row, null, group.map((_) => {
      return /* @__PURE__ */ React.createElement(Col, {
        key: _.shopId,
        span: "4"
      }, /* @__PURE__ */ React.createElement(Checkbox, {
        className: "custom-checkbox",
        indeterminate: _.shopId === "ALL" && form.getFieldValue(formKey) && form.getFieldValue(formKey).filter((_2) => _2 !== "ALL").length !== shopList.length && form.getFieldValue(formKey).filter((_2) => _2 !== "ALL").length !== 0,
        value: _.shopId
      }, /* @__PURE__ */ React.createElement(Tooltip, {
        title: _.shopName,
        placement: "topLeft"
      }, _.shopName)));
    }))));
  }));
};
